export const PitrSnapshotsMultipleDots = ({ fill }: { fill?: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      {fill ? (
        <circle cx='10' cy='12' r='6' fill={fill} />
      ) : (
        <circle
          cx='10'
          cy='12'
          r='5'
          stroke={'var(--mui-palette-text-secondary)'}
          strokeWidth='2'
        />
      )}
      <mask id='path-3-inside-1_12748_2343' fill='white'>
        <path d='M15.4941 6.18848C18.085 6.85244 20 9.20304 20 12.001C20 14.7989 18.085 17.1495 15.4941 17.8135C17.0365 16.3551 18 14.2912 18 12.001C18 9.7108 17.0365 7.64681 15.4941 6.18848Z' />
      </mask>
      <path
        d='M15.4941 6.18848C18.085 6.85244 20 9.20304 20 12.001C20 14.7989 18.085 17.1495 15.4941 17.8135C17.0365 16.3551 18 14.2912 18 12.001C18 9.7108 17.0365 7.64681 15.4941 6.18848Z'
        fill={fill}
      />
      <path
        d='M15.4941 6.18848L15.7424 5.21978L11.9997 4.26066L14.8071 6.9151L15.4941 6.18848ZM20 12.001H21H20ZM15.4941 17.8135L14.8071 17.0869L11.9997 19.7413L15.7424 18.7822L15.4941 17.8135ZM18 12.001H19H18ZM15.4941 6.18848L15.2459 7.15717C17.4051 7.71052 19 9.67069 19 12.001H20H21C21 8.7354 18.7649 5.99436 15.7424 5.21978L15.4941 6.18848ZM20 12.001H19C19 14.3313 17.4051 16.2914 15.2459 16.8448L15.4941 17.8135L15.7424 18.7822C18.7649 18.0076 21 15.2666 21 12.001H20ZM15.4941 17.8135L16.1812 18.5401C17.9146 16.9011 19 14.5779 19 12.001H18H17C17 14.0044 16.1584 15.8091 14.8071 17.0869L15.4941 17.8135ZM18 12.001H19C19 9.42407 17.9146 7.10082 16.1812 5.46186L15.4941 6.18848L14.8071 6.9151C16.1584 8.19281 17 9.99753 17 12.001H18Z'
        fill={fill}
        mask='url(#path-3-inside-1_12748_2343)'
      />
    </svg>
  );
};
